const filter = {
    // 字符串截取
    subString(value, length) {
        if (!value) {
            return "-";
        }
        value = value.trim();
        if (value.length > length) {
            var first = value.toString().substring(0, length);
            value = first + "...";
        }
        return value;
    },
    // 数字处理
    numberFormat(value) {
        value = parseInt(value);
        if (isNaN(value)) {
            return 0;
        }
        if (value >= 10000) {
            value = value + "";
            var len = value.length;
            value = value.slice(0, len - 3);
            return parseFloat(value / 10) + "万";
        } else {
            return value
        }
    },
    // 时间处理
    trustTime(inHisTime, pattern) {
        if (!inHisTime) {
            return;
        }
        inHisTime =
            inHisTime = inHisTime.toString().trim().replace(/-/gm, "/");
        var date = null,
            now = new Date();
        if (inHisTime.indexOf("/") != -1) { //yyyy-mm-dd HH:mm:ss
            date = new Date(inHisTime);
        } else {
            date = new Date(Number(inHisTime)); // long 整型
        }
        var year = date.getFullYear(),
            month = date.getMonth() + 1,
            day = date.getDate(),
            hours = date.getHours(),
            minute = date.getMinutes();
        var minuteTime = (hours < 10 ? "0" + hours : hours) + ":" + (minute < 10 ? "0" + minute : minute),
            monthTime = (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
        if (pattern && pattern.toLowerCase() === "time") {
            return minuteTime;
        } else if (now.toLocaleDateString() === date.toLocaleDateString()) {
            //当天 只显示时间
            return minuteTime;
        } else if (year === now.getFullYear()) {
            //当年 显示 月-日 时间
            return monthTime + " " + minuteTime;
        } else {
            //不是当年
            return year + "-" + monthTime + " " + minuteTime;
        }
    },
    // 时间处理
    formatDate(date, fmt="yyyy-MM-dd") {
        if(!date){
            return "";
        }
        if(typeof date == "string"){
            date = date.replace(/-/g,"/")
        }
        date = new Date(date);
        var o = {
            "M+" : date.getMonth()+1,     //月份
            "d+" : date.getDate(),     //日
            "h+" : date.getHours(),     //小时
            "m+" : date.getMinutes(),     //分
            "s+" : date.getSeconds(),     //秒
            "q+" : Math.floor((date.getMonth()+3)/3), //季度
            "S" : date.getMilliseconds()    //毫秒
        };
        if(/(y+)/.test(fmt))
            fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)
            if(new RegExp("("+ k +")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        return fmt;
    },
    //字符串
    timeSubstr(value, startLength, endLength) { //
        if (!value) return;
        return value.substring(startLength, endLength);
    },
    // 内容\n换成回车
    fmtContent(value) {
        value = value.split("\n").join("<br/>");
        return value;
    },
    //根据产品类型判断是否显示保障金额
    guaranteeLimit(content) {
        if (!content || !content.insuranceProductName) return "";
        var val = "";
        if (content.insuranceProductName.indexOf("重疾") > -1 || content.insuranceProductName.indexOf("重大疾病") > -1) {
            val = content.guaranteeLimit + "元";
        } else {
            val = "详见保障权益"
        }
        return val;
    },
    //根据产品类型判断是否显示保障金额
    policyLimit(content) {
        var val = "";
        if ((typeof content.isStricken=="string"&&content.isStricken=="true")||(typeof content.isStricken=="boolean"&&content.isStricken)) {
            val = content.totalInsured + "元";
        } else {
            val = "详见保障权益"
        }
        return val;
    },
    // 日期字数控制
    timeNum(content, num) {
        if (!content) return;
        if (num > content.length) return content;
        return content.slice(0, num);
    },

    guarateeType(text) { //交费期限
        var str = ''
        if (text == 1) {
            str = "终身"
        } else if (text == 2) {
            str = "岁"
        } else if (text == 3) {
            str = '年'
        } else if (text == 4) {
            str = '月'
        } else if (text == 5) {
            str = '天'
        }
        return str;
    },
    payType(text) { //交费类型
        var str = "";
        if (text == 1) {
            str = "年缴"
        } else if (text == 2) {
            str = "月缴"
        } else if (text == 3) {
            str = "季缴"
        }else if (text == 4) {
            str = "半年缴"
        }else if (text == 5) {
            str = "缴终生"
        }else if (text == 6) {
            str = "岁缴"
        }
        return str;
    },
  
    payment1(text) { //交费类型
        var str = "";
        if (text == 1) {
            str = "年"
        } else if (text == 2) {
            str = "月"
        } else if (text == 4) {
            str = "趸交"
        } else if (text == 5) {
            str = "缴终生"
        } else if (text == 6) {
            str = "岁"
        }
        return str;
    },
    renewal(renewalStatus){
        if(renewalStatus==2){
            return '待续费'
        }else if (renewalStatus == 5) {
            return "续费成功"
        }else if (renewalStatus == 6) {
            return "续费失败"
        }else if (renewalStatus == 7) {
            return "豁免保费"
        }else if (renewalStatus == 8) {
            return "已理赔"
        }else if (renewalStatus == 9) {
            return "已过宽末"
        }else if (renewalStatus == 10) {
            return "已退保"
        }else if (renewalStatus == 11) {
            return "健康原因"
        }else if (renewalStatus == 12) {
            return "产品原因"
        }else if (renewalStatus == 13) {
            return "经济原因"
        }else if (renewalStatus == 14) {
            return "其他"
        }
    },
    payment(text) { //交费方式
        var str = "";
        if (text == 1) {
            str = "年缴"
        } else if (text == 2) {
            str = "月缴"
        } else if (text == 4) {
            str = "趸交"
        } else if (text == 5) {
            str = "缴终身"
        } else if (text == 6) {
            str = "缴到岁"
        }
        return str;
    },
    holderCardType(text) { //证件类型
        var str = "";
        if (text == "01") {
            str = "身份证";
        } else if (text == "02") {
            str = "护照";
        } else if (text == "03") {
            str = "军人证";
        } else if (text == "04") {
            str = "出生证";
        } else if (text == "05") {
            str = "港澳台同胞证";
        } else if (text == "06") {
            str = "户口本";
        } else if (text == "07") {
            str = "港澳居民来往内地通行证";
        } else if (text == "08") {
            str = "港澳台通行证";
        } else if (text == "09") {
            str = "出生证明";
        } else if (text == "10") {
            str = "企业三合一证";
        }
        return str;
    },
    beneficiaryTypes(text) { //受益人
        var str = "";
        if (text == "1") {
            str = "法定受益人";
        } else if (text == "2") {
            str = "指定受益人";
        } else if (text == "3") {
            str = "被保险人";
        }
        return str;
    },
    holderArea(text) { //所在地区
        var str;
        if (!text || text == "{}") {
            return "-";
        }
        try {
            text = JSON.parse(text);
            if(text.district){
                str = text.province.name + "-" + text.city.name + "-" + text.district.name;
            }else{
                str = text.province.name + "-" + text.city.name
            }
            return str;
        } catch (error) {
            return text;
        }
    },
    holderHomeAddress(text) {
        if (!text || text == "null" || text == "nullnull") {
            return "-";
        }
        return text;
    },
    balanceStatus(num) { //结算状态
        var str = "";
        if (num == "1") {
            str = "未发放";
        } else if (num == "2") {
            str = "已发放";
        } else if (num == "3") {
            str = "已发放";
        } else if (num == "4") {
            str = "有异议";
        } else if (num == "5"||num=='6') {
            str = "已发放";
        }
        return str;
    },
    fixedNum(num) { //保留两位小数
        if (!num) return;
        var str = Math.floor(num * 100) / 100;
        return str;
    },
    fixedNum1(str){
        if(str){
            return (1*str).toFixed(2)
        }else{
            return '0'
        }
    },
    failMsg(text) { //失败消息
        if (!text) {
            return "--";
        } else {
            return text;
        }
    },
    beneRelationship(num) { //与被保人关系
        var str = "";
        if (num == 1) {
            str = "本人";
        } else if (num == 2) {
            str = "父母";
        } else if (num == 3) {
            str = "子女";
        } else if (num == 4) {
            str = "配偶";
        } else if (num == 5) {
            str = "兄弟姐妹";
        } else if (num == 6) {
            str = "祖父母，外祖父母";
        } else if (num == 7) {
            str = "祖孙，外祖孙";
        } else if (num == 8) {
            str = "其他";
        } else if (num == 9) {
            str = "丈夫";
        } else if (num == 10) {
            str = "妻子";
        } else if (num == 11) {
            str = "父亲";
        } else if (num == 12) {
            str = "母亲";
        } else if (num == 13) {
            str = "儿子";
        } else if (num == 14) {
            str = "女儿";
        } else if (num == 15) {
            str = "孙子";
        } else if (num == 16) {
            str = "孙女";
        } else if (num == 17) {
            str = "外孙";
        } else if (num == 18) {
            str = "外孙女";
        } else if (num == 30) {
          str = "孙子女";
        } else if (num == 31) {
          str = "外孙子女";
        }
        return str;
    },
    percent(val) { //小数点转换为百分比
        var str;
        if (!val || val == 0) {
            str = 0;
        } else {
            str = val * 100;
            str = str.toFixed(0) + "%";
        }
        return str;
    },
    percent2(val) { //小数点转换为百分比
        var str;
        if (!val || val == 0) {
            str = 0;
        } else {
            str = val * 100;
            if(!/^\d+$/.test(str)){
                str = str.toFixed(1) + "%";
            }else{
                str = str.toFixed(0) + "%";
            }
        }
        return str;
    },
    percentTwo(val) { //小数点转换为百分比
        var str;
        if (!val || val == 0) {
            str = "--";
        } else {
            str = val.toFixed(0) + "%";
        }
        return str;
    },
    percent3(val,size=2) { //小数点转换为百分比
        var str;
        if (!val || val == 0) {
            str = 0;
        } else {
            str = val * 100;
            str = str.toFixed(size)*1 + "%";
        }
        return str;
    },
    componentNum(val1, val2) {
        var val = val1 - val2;
        return val.toFixed(2);

    },

    strFixed(str){
        var string = ''
        if(str&&str.length>100){
            return str.substring(0,100)+'...'
        }else{
            return str
        }
    },
    numFixed1(num){
        var str = num+''
        if(str){
            return (num*1).toFixed(1)
        }else{
            return ''
        }
    },
    numFixed2(num){
        var str = num+''
        if(str){
            return (num*100).toFixed(1)*1
        }else{
            return ''
        }
    },
    numFixed3(num){
        var str = num+''
        if(str){
            return (num).toFixed(2)*1
        }else{
            return ''
        }
    },
    statusChange(num){
        var str = ''
        if(num==1){
            str = '待跟进'
        }else if(num>10&&num<20||num==81){
            str = '跟进中'
        }else if(num>90&&num<100){
            str = '跟进完成'
        }
        return str
    },
    serviceStatu(num){
        if(num==1){
            return '待跟进方案'
        }else if(num==2){
            return '沟通需求'
        }else if(num==3){
            return '定制方案'
        }else if(num==4){
            return '方案解读'
        }else if(num==5){
            return '跟进完成'
        }
    },
    source(str,name){
        var str1 = '';
        if(str=='mDetail'){
            str1 = '产品详情页-移动端'
        }else if(str=='pcDetail'){
            str1 = '产品详情页-PC端'
        }else if(str=='tools'){
            str1 = '首页工具栏'
        }else if(str=='xcx'){
            str1 = '掌上核保师小程序'
        }else if(str=='dxd_questionnaire'){
            str1 = '懂险帝渠道问卷'
        }else if(str=='bdgj'){
            str1 = '保单管家'
        }
        if(name&&str1){
            str1 = '('+str1+')'
        }
        return str1
    },

    // 待跟进              坐席安排：专业坐席顾问XXX
    // 确认客户需求  专业坐席顾问XXX,已经在跟预约客户联系，并了解客户需求
    // 推荐合适产品  专业坐席顾问XXX,已经推荐合适产品给客户
    // 跟进完成  专业坐席顾问XXX,已经完成预约客户跟进
    recordTitle(num,name){
        var str = ''
        if(num==1){
            str = '坐席安排：专业坐席顾问'+name
        }else if(num==11){
            str = '专业坐席顾问'+name+'，已经在跟预约客户联系，并了解客户需求'
        }else if(num==12){
            str = '专业坐席顾问'+name+'，已经推荐合适产品给客户'
        }else if(num>90&&num<100){
            str = '专业坐席顾问'+name+'，已经完成预约客户跟进'
        }
        return str
    },

    timeStatus(val){
        try {
            if(val){
                if(val.split(' ').length==2){
                    let timeArr = val.replace(/-/g, "/").split(":")
                    return timeArr[0] + ":" + timeArr[1]
                }else if(val.split(' ').length==1){
                    let time = val.replace(/-/g, "/")
                    return time
                }else{
                    return '-'
                }
            }
        } catch (error) {
            console.log(error)
            console.log('%c时间格式','color:red',val)
        }
        return '-'
    },
    timeSplit(val){
        if(val){
            try {
                if(val.split(' ').length==2){
                    let timeArr = val.replace(/-/g, "/").split(" ")
                    return timeArr[0]
                }else if(val.split(' ').length==1){
                    let time = val.replace(/-/g, "/")
                    return time
                }else{
                    return '-'
                }
            } catch (error) {
                console.log(error)
                console.log('%c时间格式','color:red',val)
            }
        }
        return '-'
    },
    //身份证手机号中间加*
    //str：要进行隐藏的变量  frontLen: 前面需要保留几位    endLen: 后面需要保留几位
    hidden(str,frontLen=2,endLen=2) {  
        if(str){
            var len = str.length-frontLen-endLen;
            var xing = '';
            for (var i=0;i<len;i++) {
            xing+='*';
           }
            return str.substring(0,frontLen)+xing+str.substring(str.length-endLen);
        }
        return '-'
  },
  hiddenEmail(str,frontLen=2,endLen=2){
    if(str){
        if(str.indexOf('@')!=-1){
            let strArr=str.split('@')
            let len = strArr[0].length-frontLen-endLen;
            let xing = '';
            for (var i=0;i<len;i++) {
            xing+='*';
           }
           let numStr = strArr[0].substring(0,frontLen)+xing+strArr[0].substring(strArr[0].length-endLen);
           return numStr+'@'+strArr[1]
        }
    }
    return '-'
  },
  filterPayType(text) { //交费类型
    var str = "";
    if (text == 1) {
        str = "年交"
    } else if (text == 2) {
        str = "月交"
    } else if (text == 3) {
        str = "季交"
    }else if (text == 4) {
        str = "半年交"
    }else if (text == 5) {
        str = "交终生"
    }else if (text == 6) {
        str = "岁交"
    }else {
        return '-'
    }
    return str;
},
filterRenewal(val) {
  if (val == '2') {
    return '待续费'
  } else if (val == '5') {
    return '续费成功'
  } else if (val >= '6') {
    return '续费失败'
  }
},
// 空数据处理
filterEmpty(val) {
    if (!val) {
      return "-";
    }
    return val;
  },
  // 时间处理 当年 月日 非当年 年月日
  trustTime2(inHisTime) {
    if (!inHisTime) {
      return;
    }
    inHisTime =
      inHisTime = inHisTime.toString().trim().replace(/-/gm, "/");
    var date = null,
      now = new Date();
    if (inHisTime.indexOf("/") != -1) { //yyyy-mm-dd HH:mm:ss
      date = new Date(inHisTime);
    } else {
      date = new Date(Number(inHisTime)); // long 整型
    }
    var year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate(),
      hours = date.getHours(),
      minute = date.getMinutes();
    var minuteTime = (hours < 10 ? "0" + hours : hours) + ":" + (minute < 10 ? "0" + minute : minute),
      monthTime = (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
    if (year === now.getFullYear()) {
      //当年 显示 月-日 时间
      return monthTime;
    } else {
      //不是当年
      return year + "-" + monthTime;
    }
  },
}

export {
    filter
}
